<div class="form-card">
    <!--SKS22NOV24 Time Info -->
    <div class="col-md-12 mt-3">
        <div class="static-width-for-card width-100">
            <app-cards #hideplainview [inlineDetailed]="true">
                <!-- SKS22NOV24 when a HTML element has a class 'header-sectio', it will get rendered in the 'card-header' in the component's HTML -->
                <div class="header-section flex content-space-between">
                    <span>Time Management</span>
                    <div class="card-btn show-detail-view">
                        <!-- SKS22NOV24 data-bs-toggle="modal" data-bs-target="#cardDetailedModal" -->
                        <svg-icon src="../assets/images/icons/general/pencil-icon.svg"
                            class="card-icon" (click)="setDatas()"></svg-icon>
                    </div>
                </div>
                <div class="body-section card-text">
                    <div class="d-flex flex-column">
                        <label>Company Work Time</label>
                        <div class="d-flex flex-row mt-4 justify-content-start">
                            <div class="d-flex ms-2 flex-column width-50">
                                <label class="label-head">Start Time</label>
                                <label class="label-sub">{{settingsData?.employeeWorkTime?.startTime || '-'}}</label>
                            </div>
                            <div class="d-flex flex-column width-50">
                                <label class="label-head">End Time</label>
                                <label class="label-sub">{{settingsData?.employeeWorkTime?.endTime || '-'}}</label>
                            </div>
                        </div>
                        <label class="mt-3">Grace Hours</label>
                        <div class="d-flex flex-row mt-4 justify-content-start">
                            <div class="d-flex ms-2 flex-column width-50">
                                <label class="label-head">CheckIn</label>
                                <label class="label-sub">{{settingsData?.graceHours?.checkIn || '-'}}</label>
                            </div>
                            <!-- SKS22NOV24 -->
                            <div class="d-flex flex-column width-50">
                                <label class="label-head">CheckOut</label>
                                <label class="label-sub">{{settingsData?.graceHours?.checkOut || '-'}}</label>
                            </div>
                        </div>
                        <div class="d-flex flex-row mt-4 justify-content-start">
                            <div class="d-flex ms-2 flex-column width-50">
                                <label class="label-head">Working Hours</label>
                                <label class="label-sub">{{settingsData?.workingHours || '-'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-expanded-section detailed-section" plain>
                    <!-- 'plain' or 'modal' based on the requirement -->
                    <div class="card-header"><b>Edit Time Settings</b></div>
                    <div class="card-body">
                        <form [formGroup]="timeSettingForm">
                            <div class="field-sets">
                                <div class="field-set-row flex">
                                    <!-- <span>Company Work Time</span> -->
                                    <div class="field-input col-md-6"
                                        [class]=" timeSettingForm.controls['startTime'].invalid && timeSettingForm.controls['startTime'].touched ? 'has-error' : '' ">
                                    
                                        <label class="form-label additional-info-label">Company Work Time</label><br>
                                        <label for="first-name" class="form-label label-txt modal-field-label">Start Time*</label>
                                        <input type="time" formControlName="startTime" id="start-time"
                                            placeholder="">
                                        
                                        <!-- Updated the error message with formbuilder pattern-->
                                        <p class="error-msg">
                                            <span
                                                *ngIf="timeSettingForm.controls['startTime'].invalid && timeSettingForm.controls['startTime'].touched && !this.timeSettingForm.controls['startTime'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>This field is required
                                            </span>
                                            <span
                                                *ngIf="timeSettingForm.controls['startTime'].touched && this.timeSettingForm.controls['startTime'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>Please enter a valid name
                                            </span>
                                        </p>
                                    </div>
                                    <div class="field-input mt-2 col-md-6"
                                        [class]=" timeSettingForm.controls['endTime'].invalid && timeSettingForm.controls['endTime'].touched ? 'has-error' : '' ">
                                        <label class="form-label additional-info-label"></label><br>
                                        <label for="bank-name" class="form-label label-txt modal-field-label">End Time*</label>
                                        <input type="time" formControlName="endTime" id="end-time" placeholder="" >
                                        
                                        <!-- Updated the error message with formbuilder pattern-->
                                        <p class="error-msg">
                                            <span
                                                *ngIf="timeSettingForm.controls['endTime'].invalid && timeSettingForm.controls['endTime'].touched && !this.timeSettingForm.controls['endTime'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>This field is required
                                            </span>
                                            <span
                                                *ngIf="timeSettingForm.controls['endTime'].touched && this.timeSettingForm.controls['endTime'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>Please enter a valid name
                                            </span>
                                        </p>
                                    </div>
                                    <div class="field-input col-md-6"
                                        [class]=" timeSettingForm.controls['CheckIn'].invalid && timeSettingForm.controls['CheckIn'].touched ? 'has-error' : '' ">
                                        <label class="form-label additional-info-label">Grace Hours</label><br>
                                        <label for="account-number" class="form-label label-txt modal-field-label">CheckIn*</label>
                                        <input type="number" formControlName="CheckIn" id="account-number" placeholder="" >
                                        <!-- Updated the error message with formbuilder pattern-->
                                        <p class="error-msg">
                                            <span
                                                *ngIf="timeSettingForm.controls['CheckIn'].invalid && timeSettingForm.controls['CheckIn'].touched && !this.timeSettingForm.controls['CheckIn'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>This field is required
                                            </span>
                                            <span
                                                *ngIf="timeSettingForm.controls['CheckIn'].touched && this.timeSettingForm.controls['CheckIn'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>Please enter a valid number
                                            </span>
                                        </p>
                                    </div>
                                    <div class="field-input mt-4 col-md-6"
                                        [class]=" timeSettingForm.controls['CheckOut'].invalid && timeSettingForm.controls['CheckOut'].touched ? 'has-error' : '' " style="padding-top: 3.5px">
                                        <label for="branch-name" class="form-label label-txt modal-field-label">CheckOute*</label>
                                        <input type="number" formControlName="CheckOut" id="branch-name" placeholder="" >
                                        <!--SKS22NOV24 Updated the error message with formbuilder pattern-->
                                        <p class="error-msg">
                                            <span
                                                *ngIf="timeSettingForm.controls['CheckOut'].invalid && timeSettingForm.controls['CheckOut'].touched && !this.timeSettingForm.controls['CheckOut'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>This field is required
                                            </span>
                                            <span
                                                *ngIf="timeSettingForm.controls['CheckOut'].touched && this.timeSettingForm.controls['CheckOut'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg">
                                                </svg-icon>Please enter a valid name
                                            </span>
                                        </p>
                                    </div>
                                    <div class="field-input col-md-6"
                                        [class]="timeSettingForm.controls['workingHours'].invalid && timeSettingForm.controls['workingHours'].touched ? 'has-error' : ''">
                                        <label for="branch-name" class="form-label label-txt modal-field-label">Working Hours*</label>
                                        <input type="number" formControlName="workingHours" id="branch-name" min="0" max="12" placeholder="Enter hours (0-12)">
                                        
                                        <!--SKS22NOV24 Updated the error message with formbuilder pattern-->
                                        <p class="error-msg">
                                            <span
                                                *ngIf="timeSettingForm.controls['workingHours'].invalid && timeSettingForm.controls['workingHours'].touched && !timeSettingForm.controls['workingHours'].hasError('pattern')">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg"></svg-icon>
                                                This field is required
                                            </span>
                                            <span
                                                *ngIf="timeSettingForm.controls['workingHours'].touched && timeSettingForm.controls['workingHours'].value > 12">
                                                <svg-icon src="../assets/images/icons/general/warning icon.svg"></svg-icon>
                                                Please enter a value between 0 and 12
                                            </span>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer border-0">
                        <div class="center-button text-right" style="margin-top:-50px">
                            <app-fusion-button [buttonValue]="'Cancel'"
                                [buttonType]="'text-only card-btn hide-detail-view'" [dataDismiss]="''"
                                (buttonClickEmit)="timeSettingForm.reset()" [fcBtnId]="'myId'"></app-fusion-button>
                                <app-fusion-button [buttonValue]="'Save'" (buttonClickEmit)="setData();hideplainview.hidePlainView()"
                                [fcBtnId]="'submit'" [buttonType]="'input-button'" [buttonDisable]="!timeSettingForm.valid" ></app-fusion-button>    
                    </div>    
                    </div>
                </div>
            </app-cards>
        </div>
    </div>
</div>